export default "//yastatic.net/s3/distribution/pythia/frontend/_/31f3cfc79c371e83b2d9542ea2abadae.png";